import React from 'react';
import { Link } from 'react-router-dom';
import ProfileHeader from '../components/layout/header/ProfileHeader';
import Footer from '../components/layout/Footer';
import {
  FaWallet,
  FaChevronDown,
  FaCreditCard,
  FaBuilding,
} from 'react-icons/fa';
import { useLocation } from 'react-router';
const Payment = (props) => {
  const location = useLocation();
  const buy = location.pathname;
  console.log(buy);

  // const Buy1 = location.pathname;
  // console.log(Buy1);
  // const Buy1 = async (e) => {
  //   const amount = amount1;
  //   const team = team1Id;
  //   const player = player1;

  //   const response = await axios
  //     .post(`/api/v1/stakes/buystake`, {
  //       event,
  //       amount,
  //       team,
  //       player,
  //       user,
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       console.log('Bought Successfully');
  //     })
  //     .catch((err) => console.log(err.response.data.error));

  //   setAmount1('');
  // };
  // const Buy2 = async (e) => {
  //   const amount = amount2;
  //   const team = team2Id;
  //   const player = player1;

  //   const response = await axios
  //     .post(`/api/v1/stakes/buystake`, {
  //       event,
  //       amount,
  //       team,
  //       player,
  //       user,
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       console.log('Bought Successfully');
  //     })
  //     .catch((err) => console.log(err.response.data.error));

  //   setAmount2('');
  // };
  return (
    <div className='pt-5'>
      <ProfileHeader />
      <div className='container-md-fluid py-5 my-4 d-flex justify-content-center'>
        <div
          className=''
          style={{
            width: '90%',
            // height: "180vh",
            borderRadius: '1.938rem',
            backgroundColor: '#F8F8F8',
          }}
        >
          <div className='mx-3 my-5 py-2'>
            <h4>Saved Payment Option</h4>
            <div
              className='border border-dark mt-4 rounded-1'
              style={{ backgroundColor: '#FFF', width: '100%' }}
            >
              <div class='form-check mx-5 my-4 pt-2'>
                <input
                  style={{ width: '1.6rem', height: '1.6rem' }}
                  class='form-check-input border border-dark mt-2'
                  type='radio'
                  //   name="flexRadioDefault"
                  //   id="flexRadioDefault1"
                />
                <div className='d-flex justify-content-between'>
                  <label class='form-check-label ps-md-4 ms-3'>
                    <h5 className='fw-bold'>Bank Name</h5>
                    <h6 className=''>***** 1234</h6>
                  </label>
                  <div className='d-flex flex-column gap-2'>
                    <img
                      style={{ width: '6rem', height: '1.938rem' }}
                      src={'/assests/VISA.png'}
                      alt='VISA'
                      className='img-fluid'
                    />
                    <h6 className='mt-0'>User Name</h6>
                  </div>
                </div>
              </div>
            </div>
            <h4 className='fw-bold pt-5'>Other Payment Options</h4>
            <div
              className='border border-dark mt-4 rounded-1'
              style={{ backgroundColor: '#FFF', width: '100%' }}
            >
              <div className='d-flex flex-column mx-5 my-5'>
                <div className='d-flex justify-content-between mb-4 border-bottom'>
                  <div className='d-flex gap-3 mb-4'>
                    <FaWallet size={20} />
                    <h5>KIBI Wallet</h5>
                  </div>
                  <FaChevronDown />
                </div>
                <div className='d-flex justify-content-between mb-4 border-bottom mt-2'>
                  <div className='d-flex gap-3 mb-4'>
                    <FaCreditCard size={20} />
                    <h5>Credit/Debit Card</h5>
                  </div>
                  <FaChevronDown />
                </div>
                <div className='d-flex justify-content-between mb-4 border-bottom mt-2'>
                  <div className='d-flex gap-3 mb-4'>
                    <FaBuilding size={20} />
                    <h5>NET Banking</h5>
                  </div>
                  <FaChevronDown />
                </div>
                <div className='d-flex justify-content-between mt-3'>
                  <div className='d-flex gap-3'>
                    <FaCreditCard size={20} />
                    <h5>Phone Pay/Google Pay/BHIM UPI</h5>
                  </div>
                  <FaChevronDown />
                </div>
              </div>
            </div>
            <h5 className='fw-bold pt-4 mt-3'>Price Details</h5>
            <div className='d-flex justify-content-between pe-5 pt-4 border-bottom pb-3'>
              <h5>Total Amount</h5>
              <h5>5,000</h5>
            </div>
            <div className='d-flex justify-content-between pe-5 pt-4'>
              <h5 className='fw-bold'>Total Amount</h5>
              <h5 className='fw-bold'>5,000</h5>
            </div>

            <div className='pt-4 mt-2 d-md-flex text-center justify-content-between'>
              <Link to='/buystakes'>
                <button className='cancelBtn p-3 rounded '>Cancel</button>
              </Link>

              <button className='cancelBtn p-3 rounded gapTop3 '>
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Payment;
